module.exports = __webpack_public_path__ + "img/bj.2ebad683.svg";